import { Chip } from '@patchbay/ui'
import { formatOfficeDateTime } from '../lib/toronto-time'

export interface EmailReceipt {
  delivered_at?: string | null
  first_opened_at?: string | null
  last_opened_at?: string | null
  open_count?: number
  open_client?: Record<string, unknown>
  open_os?: Record<string, unknown>
  open_platform?: string | null
  bounced_at?: string | null
  bounce_type?: string | null
  bounce_description?: string | null
  spam_complaint_at?: string | null
  spam_complaint_description?: string | null
}

function clock(value?: string | null): string {
  const stamp = formatOfficeDateTime(value)
  return stamp === 'Window not supplied' ? '' : stamp.replace(/^.*?,\s*/, '')
}

function named(value: Record<string, unknown> | undefined): string | null {
  if (!value) return null
  for (const key of ['Name', 'name', 'Family', 'family']) {
    if (typeof value[key] === 'string' && value[key]) return value[key]
  }
  return null
}

export function EmailReceiptChips({ receipt }: { receipt?: EmailReceipt | null }) {
  if (!receipt) return null
  const device = [named(receipt.open_client), named(receipt.open_os), receipt.open_platform].filter(Boolean).join(' · ')
  const openedAt = receipt.first_opened_at || receipt.last_opened_at
  return (
    <span className="inline-flex flex-wrap items-center gap-1">
      {receipt.spam_complaint_at ? (
        <Chip tone="danger" size="sm" title={receipt.spam_complaint_description ?? undefined}>
          Spam complaint
        </Chip>
      ) : null}
      {receipt.bounced_at ? (
        <Chip tone="danger" size="sm">
          Bounced: {receipt.bounce_description || receipt.bounce_type || 'delivery failed'}
        </Chip>
      ) : null}
      {receipt.delivered_at ? (
        <Chip tone="success" size="sm">
          Delivered {clock(receipt.delivered_at)}
        </Chip>
      ) : null}
      {openedAt ? (
        <Chip tone="primary" size="sm" title={device || undefined}>
          Opened {clock(openedAt)}
          {(receipt.open_count ?? 0) > 1 ? ` · ${receipt.open_count} opens` : ''}
        </Chip>
      ) : !receipt.bounced_at && !receipt.spam_complaint_at ? (
        <Chip tone="neutral" size="sm">
          Not opened yet
        </Chip>
      ) : null}
    </span>
  )
}
